/** The "Brand // Theme" naming convention, split for display. The stored
 *  name is untouched (search, Slack, exports keep the full name); screens
 *  that have room render the brand part as a small eyebrow and the theme
 *  as the actual title. Names without "//" have no eyebrow. */
export const splitCampaignName = (name: string): { eyebrow: string | null; title: string } => {
  const i = name.indexOf('//');
  if (i === -1) return { eyebrow: null, title: name };
  const eyebrow = name.slice(0, i).trim();
  const title = name.slice(i + 2).trim();
  if (!eyebrow || !title) return { eyebrow: null, title: name };
  return { eyebrow, title };
};
